// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Newsletter-module--anchor--3fCYP","wrapper":"Newsletter-module--wrapper--1nkhV","title":"Newsletter-module--title--3nzeJ","image":"Newsletter-module--image--2S36k"};